module.exports = __webpack_public_path__ + "img/4.8996a8c5.png";